import { map } from 'lodash/fp';

export const toOptions = map(({ description, ...rest }) => ({
  label: description,
  value: {
    description,
    ...rest,
  },
}));
